import { IApiResponse } from 'src/app/core/interfaces/api/api-response.interface';

export abstract class AbstractEnrollmentService {
  abstract submitBusinesType(model: unknown): Promise<IApiResponse>;
  abstract submitBusinessIndustry(model: unknown): Promise<IApiResponse>;
  abstract submitCustomerType(model: unknown): Promise<IApiResponse>;
  abstract submitStateofOrg(model: unknown): Promise<IApiResponse>;
  abstract submitDBA(model: unknown): Promise<IApiResponse>;
  abstract submitCompanyAddress(model: unknown): Promise<IApiResponse>;
  abstract submitAnnualRevenue(model: unknown): Promise<IApiResponse>;
  abstract submitCompanyWebsite(model: unknown): Promise<IApiResponse>;
  abstract submitYearFounded(model: unknown): Promise<IApiResponse>;
  abstract submitNumberOfEmployees(model: unknown): Promise<IApiResponse>;
  abstract submitInvoiceMethod(model: unknown): Promise<IApiResponse>;
  abstract submitLendingMethod(model: unknown): Promise<IApiResponse>;
  abstract confirmDetails(model: unknown): Promise<IApiResponse>;
  abstract confirmCompanyMatch(model: unknown): Promise<IApiResponse>;
}
